import React from 'react';

function Plus(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 4.00488C12.3452 4.00488 12.625 4.2847 12.625 4.62988V19.3755C12.625 19.7207 12.3452 20.0005 12 20.0005C11.6548 20.0005 11.375 19.7207 11.375 19.3755V4.62988C11.375 4.2847 11.6548 4.00488 12 4.00488Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.0022 12.0029C4.0022 11.6578 4.28202 11.3779 4.6272 11.3779H19.3724L19.3728 12.6279H4.6272C4.28202 12.6279 4.0022 12.3481 4.0022 12.0029ZM19.9978 12.0029C19.9978 12.3481 19.7179 12.6279 19.3728 12.6279L19.3724 11.3779C19.7176 11.3779 19.9978 11.6578 19.9978 12.0029Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Plus;
